import { render, staticRenderFns } from "./Tracking.vue?vue&type=template&id=78af051e&scoped=true&"
import script from "./Tracking.vue?vue&type=script&lang=js&"
export * from "./Tracking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78af051e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78af051e')) {
      api.createRecord('78af051e', component.options)
    } else {
      api.reload('78af051e', component.options)
    }
    module.hot.accept("./Tracking.vue?vue&type=template&id=78af051e&scoped=true&", function () {
      api.rerender('78af051e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Tracking.vue"
export default component.exports